import { animate, query, style, transition, trigger } from '@angular/animations';

export const routeTransition = trigger('routeTransition', [
  transition('* <=> *', [
    query(':enter', [
      style({ opacity: 0 }),
      animate('.50s', style({ opacity: 1 }))
    ], { optional: true }),
    query(':leave', [
      style({ display: 'none' }),
    ], { optional: true })
  ])
])

export const fadingTransition = trigger('fadingTransition', [
  transition('* <=> *', [
    query(':enter', [
      style({  }),
      
    ], { optional: true }),
    query(':leave', [
      style({ position: 'absolute', zIndex: 1, transform: 'translateY(0px)', opacity: .8 }),
      animate('.50s', style({transform: 'translateY(20px)', opacity: 0 }))
    ], { optional: true })
  ])
])